import { JailCardStore } from '@stores/JailCardStore';

// Updated interface
interface JailCardView {
  jailCards: {
    id: number;
    cohortUserId: number;
    used: boolean;
    usedOn: string | null;
  }[];
}

export class AdminJailCardViewCreator {
  constructor(private readonly jailCardStore: JailCardStore = new JailCardStore()) {}

  public async CreateView(cohortUserId: number): Promise<JailCardView> {
    // Get the content from the API
    const jailCards = await this.jailCardStore.AdminReadByCohortUserId(cohortUserId);

    // Return the view
    return {
      jailCards: jailCards,
    };
  }
}
